import { Backdrop, Button, CircularProgress } from "@mui/material";
import { useEffect, useState } from "react";
import { useSearchParams } from "react-router-dom";
import BodyText from "../../components/BodyText";
import Title from "../../components/Title";
import styles from "./UnsubscribePage.module.css";
import ErrorPage from "../ErrorPage/ErrorPage";
import API from "../../api/API";
import SubTitle from "../../components/SubTitle";

let hasFetched = false;
let encryptedEmail: string | null = null;

const UnsubscribePage = () => {
  const [email, setEmail] = useState<string>();
  const [loading, setLoading] = useState(true);
  const [errorMessage, setErrorMessage] = useState<string>();
  const [unsubscribed, setUnsubscribed] = useState(false);

  const [searchParams] = useSearchParams();

  useEffect(() => {
    if (hasFetched) return;
    hasFetched = true;

    encryptedEmail = searchParams.get("p");
    if (!encryptedEmail) {
      setErrorMessage("Missing URL parameters");
      return;
    }

    API.get(`customers/hiddenEmail?encryptedEmail=${encryptedEmail}`)
      .then((response) => setEmail(response.data.hiddenEmail))
      .catch((error : any) => {
        setErrorMessage("Unknown Error");
        console.error(`Error calling 'customers/hiddenEmail?encryptedEmail=email' api`, error, { file: 'unsubscribePage.tsx', timeStamp: new Date().toISOString()});
      })
      .finally(() => setLoading(false));
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [searchParams]);

  const unsubscribeHandler = () => {
    setLoading(true);

    API.get(`customers/unsubscribe?encryptedEmail=${encryptedEmail}`)
      .then(() => setUnsubscribed(true))
      .catch((error: any) => { setErrorMessage("Unknown Error");
        console.error(`Error calling 'customers/unsubscribe?encryptedEmail=email' api`, error, { file: 'unsubscribePage.tsx', timeStamp: new Date().toISOString()});
      })
      .finally(() => setLoading(false));
  };

  return errorMessage ? (
    <ErrorPage message={errorMessage} buttonConfig={{ showButton: false }} />
  ) : (
    <div className={styles.page}>
      <Title color="#2149eb" sx={{ mt: "5vh" }} center>
        Cosmo DataPlans
      </Title>
      <BodyText sx={{ my: "3vh" }} center>
        {email}
      </BodyText>
      {unsubscribed ? (
        <>
          <SubTitle color="#d63131">Opt Out Successful!</SubTitle>
          <BodyText center>
            You&apos;ll no longer receive the following type of email communication from this sender.
          </BodyText>
        </>
      ) : (
        <>
          <BodyText center>Please click on the below button to Unsubscribe.</BodyText>
          <Button variant="contained" sx={{ px: "50px", mt: "2vh" }} onClick={unsubscribeHandler}>
            Unsubscribe
          </Button>
        </>
      )}

      <Backdrop sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1 }} open={loading} onClick={() => {}}>
        <CircularProgress color="inherit" />
      </Backdrop>
    </div>
  );
};
export default UnsubscribePage;
